<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    description?: string
    disabled?: boolean
    variant?: 'plain' | 'card'
    density?: 'compact' | 'default'
  }>(),
  {
    title: undefined,
    description: undefined,
    disabled: undefined,
    variant: 'plain',
    density: 'default',
  },
)
const titleId = useId()
</script>
<template>
  <fieldset
    class="ui-form-section"
    :class="[`ui-form-section--${variant}`, `ui-form-section--${density}`]"
    :disabled="disabled"
    :aria-labelledby="title || $slots.title ? titleId : undefined"
  >
    <div
      v-if="title || $slots.title || $slots.actions"
      class="ui-form-section-heading"
    >
      <h3
        v-if="title || $slots.title"
        :id="titleId"
        class="ui-form-section-title"
      >
        <slot name="icon" /><slot name="title">{{ title }}</slot>
      </h3>
      <div
        v-if="$slots.actions"
        class="ui-form-section-actions"
      >
        <slot name="actions" />
      </div>
    </div>
    <p
      v-if="description || $slots.description"
      class="ui-form-section-description"
    >
      <slot name="description">{{ description }}</slot>
    </p>
    <div class="ui-form-section-body"><slot /></div>
  </fieldset>
</template>
